import { CheckboxInputProps } from './CheckboxInput.types';
import { Checkbox, FormHelperText, Grid } from '@mui/material';
import FormControlLabel from '@mui/material/FormControlLabel';
import { useController } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

export function CheckboxInput({
  control,
  name,
  label,
  readOnly = false,
  gridSize = 6,
  defaultValue,
  ...props
}: CheckboxInputProps) {
  const {
    field: { ref, value, ...inputProps },
    fieldState: { error },
  } = useController({
    name,
    control,
    defaultValue,
  });

  const { t } = useTranslation();

  return (
    <Grid item xs={gridSize}>
      <FormControlLabel
        control={<Checkbox {...inputProps} checked={value} key={name} id={name} disabled={readOnly} {...props} />}
        label={label}
      />
      <FormHelperText>{error && t(error.message as string)}</FormHelperText>
    </Grid>
  );
}
